/**
 * 萤石设备列表 PermissionA5 子树。
 * rootPath: ysDeviceList
 */
const ysDeviceList = {
  pageReload: {
    buttonCodes: ['ys:reload']
  }
}

export default ysDeviceList
